import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 41,
	height: 40,
	viewBox: "0 0 41 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.2778 9.88889H12.3889C11.6227 9.88889 10.8879 10.1933 10.3461 10.735C9.80436 11.2768 9.5 12.0116 9.5 12.7778V30.1111C9.5 30.8773 9.80436 31.6121 10.3461 32.1539C10.8879 32.6956 11.6227 33 12.3889 33H26.8333C27.5995 33 28.3343 32.6956 28.8761 32.1539C29.4179 31.6121 29.7222 30.8773 29.7222 30.1111V12.7778C29.7222 12.0116 29.4179 11.2768 28.8761 10.735C28.3343 10.1933 27.5995 9.88889 26.8333 9.88889H23.9444M15.2778 9.88889C15.2778 10.6551 15.5821 11.3899 16.1239 11.9316C16.6657 12.4734 17.4005 12.7778 18.1667 12.7778H21.0556C21.8217 12.7778 22.5565 12.4734 23.0983 11.9316C23.6401 11.3899 23.9444 10.6551 23.9444 9.88889M15.2778 9.88889C15.2778 9.12271 15.5821 8.38791 16.1239 7.84614C16.6657 7.30436 17.4005 7 18.1667 7H21.0556C21.8217 7 22.5565 7.30436 23.0983 7.84614C23.6401 8.38791 23.9444 9.12271 23.9444 9.88889M15.2778 22.8889L18.1667 25.7778L23.9444 20",
		stroke: "#7F8083",
		strokeWidth: 2.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCheck;
